



























































































































import { Component } from 'vue-property-decorator';

import AdminService from '@/api/AdminService';

import { HeaderList, List } from '@/components/Table/TableModel';
import {
  CustomSelectModel,
  CustomSelectGroup,
  CustomSelectOption
} from '@/components/CustomSelect/CustomSelectModel';
import RowsTable from '@/components/Table/RowsTable.vue';
import BasePagination from '@/components/BasePagination/BasePagination.vue';
import ContextMenu from '@/components/ContextMenu/ContextMenu.vue';
import TextInput from '@/components/TextInput/TextInput.vue';
import CustomSelect from '@/components/CustomSelect/CustomSelect.vue';
import ContentContainer from '@/components/molecules/ContentContainer/ContentContainer.vue';
import Checkbox from '@/components/Checkbox/Checkbox.vue';
import Table from '@/components/molecules/Table/Table.vue';
import TableFilters from '@/components/molecules/TableFilters/TableFilters.vue';
import TableCell from '@/components/molecules/TableCell/TableCell.vue';
import TableHeader from '@/components/molecules/TableHeader/TableHeader.vue';
import TableRow from '@/components/molecules/TableRow/TableRow.vue';
import UserIcon from '@/components/molecules/UserIcon/UserIcon.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';

import { EBusinessStatus } from '@/models/business';

import eventBus from '@/utils/eventBus';
import DateUtils from '@/utils/DateUtils';
import { toNumber, treatValue } from '@/utils/moneyTreatments';

@Component({
  components: {
    Table,
    RowsTable,
    ContextMenu,
    TextInput,
    CustomSelect,
    ContentContainer,
    TableFilters,
    TableCell,
    TableHeader,
    TableRow,
    UserIcon,
    Checkbox,
    Typography
  }
})
export default class CoinStore extends BasePagination {
  treatValue = treatValue;

  limit = 20;
  service: AdminService = new AdminService();
  businessList: List = new List([], []);
  searchableFields = 'searchableFields=business.name';
  sortField = 'coinStore.coins';
  sortOrder = 'DESC';
  overviewData: any = {};
  filterValuesSeparator = ':';
  typeFilterModel: any = [];

  detailData: any = {};

  get overview() {
    return {
      coinsAvailable: toNumber(this.overviewData.coinsAvailable || ''),
      coinsSold: toNumber(this.overviewData.coinsSold || ''),
      revenue: toNumber(this.overviewData.revenue || '')
    };
  }

  created() {
    eventBus.$on('reloadCoinStore', this.reloadCoinStore);
    this.loadOverview();
    this.initFilterType();
  }

  reloadCoinStore() {
    this.reloadList(true, true, undefined, undefined, (list: any[]) => {
      if (this.detailData) {
        const business = list.find(item => item.id === this.detailData.data.id);
        eventBus.$emit('reloadCoinStoreDetail', business);
      }
    });
    this.loadOverview();
  }

  getNumber(str: string) {
    return toNumber(str);
  }

  initFilterModel() {
    const actionGroup = new CustomSelectGroup([
      new CustomSelectOption('notNull', `Yes`),
      new CustomSelectOption('null', `No`)
    ]);

    this.filterModel = new CustomSelectModel(
      [actionGroup],
      `Filter by circulation`,
      false,
      true,
      true,
      false
    );
  }

  initFilterType() {
    const actionGroup = new CustomSelectGroup([
      new CustomSelectOption('online', `Online`),
      new CustomSelectOption('physical', `Physical`),
      new CustomSelectOption('physical_online', `Both`)
    ]);

    this.typeFilterModel = new CustomSelectModel(
      [actionGroup],
      `Filter by type`,
      false,
      true,
      true,
      false
    );
  }

  initHeader() {
    const header = [
      new HeaderList(`Business image`, 'none', '12px'),
      new HeaderList(`Business name`, 'name'),
      new HeaderList(`Type`, 'type'),
      new HeaderList(`In Circulation`, 'coinsInCirculation'),
      new HeaderList(`Coins available`, 'coinsAvailable'),
      new HeaderList(`Coins sold`, 'coinsSold'),
      new HeaderList('', 'none')
    ];
    this.businessList.header = header;
  }

  async loadOverview() {
    const { data } = await this.service.getCoinStoreOverview();
    this.overviewData = data;
  }

  reloadList(
    clearList?: boolean,
    refreshCurrent?: boolean,
    query?: string,
    notEmpty?: boolean,
    onFinish?: any
  ) {
    if (clearList) {
      this.resetPagination();
      if (!notEmpty) this.businessList.list = [];
      this.maxItems = false;
    }
    if (this.refreshing || this.maxItems) return;
    this.$showLoaderWithLocker();
    this.refreshing = true;
    this.service
      .getCoinStoreList({
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        pagination: this.pagination,
        filters: this.query
      })
      .then(response => {
        const { data } = response;
        const { items, links } = data;
        if (refreshCurrent) {
          this.resetPagination();
          this.pagination = decodeURIComponent(links.next);
          if (!links.next) this.maxItems = true;
          this.businessList.list = this.addRowsToList(items);
        } else {
          this.businessList.list = this.businessList.list.concat(
            this.addRowsToList(items)
          );
          if (!links.next) this.maxItems = true;
          this.pagination = decodeURIComponent(links.next);
        }
        if (onFinish) onFinish(this.businessList.list);
      })
      .catch(() => {})
      .finally(() => {
        if (this.hasLoadedMore && notEmpty) {
          const listElement = this.$refs.list as HTMLElement;
          listElement.scrollTo(0, 0);
          this.hasLoadedMore = false;
        }

        this.$hideLoader();
        this.refreshing = false;
      });
  }

  getCirculationValue(hasCoinsInCirculation: boolean) {
    return hasCoinsInCirculation ? 'success' : 'warning';
  }

  getDealImageBackground(business: any) {
    if (!business.dealImage) {
      return {};
    }
    return {
      backgroundImage: `linear-gradient(to left, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 1) 150px), url('${
        business.dealImage
      }')`,
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'right'
    };
  }

  addRowsToList(businessRows: any[]): any[] {
    return businessRows.map((business: any) => ({
      id: business.id,
      picture: JSON.parse(business.logo).small,
      dealImage: business.dealImage && JSON.parse(business.dealImage).large,
      name: business.name,
      mail: business.managerMail,
      managerName: business.managerName,
      status: EBusinessStatus.active,
      circulation: business.coinsInCirculation,
      type: business.type,
      coinsSold: business.coinsSold,
      revenue: business.revenue,
      coinsAvailable: business.coinsAvailable,
      coinStoreId: business.coinStoreId,
      createdAt: DateUtils.formatISODate(business.createdAt),
      sellCoinsBonus: business.sellCoinsBonus
    }));
  }

  openBusinessDetail(event: any) {
    const modalConfig = {
      isOpen: true,
      component: 'adminCoinStoreDetails',
      data: event,
      width: '750px'
    };
    this.detailData = modalConfig;
    eventBus.$emit('setSideModalVisible', modalConfig);
  }

  beforeDestroy() {
    eventBus.$off('reloadCoinStore', this.reloadCoinStore);
  }
}
